import React from 'react';
import { Helmet } from 'react-helmet-async';

const BusinessVerification = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Business Verification - RMQ HOLDINGS INC | EIN: 99-1828959</title>
        <meta name="description" content="Verified business entity: RMQ HOLDINGS INC (DBA: RMQ Digital). EIN: 99-1828959. Address: 2022 EAST 9TH STREET, BROOKLYN, NY 11223. Owner: MOSHE QUBRUSI. A2P registered." />
        <meta name="keywords" content="business verification, RMQ HOLDINGS INC, EIN 99-1828959, A2P registration, verified business, Brooklyn NY" />
      </Helmet>
      
      <section style={{padding: '4rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '2rem', color: '#1f2937', fontFamily: 'Space Grotesk'}}>Business Verification</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            <div style={{background: '#ede9fe', padding: '2rem', borderRadius: '12px', marginBottom: '2rem', border: '2px solid #8b5cf6'}}>
              <h2 style={{color: '#6d28d9', marginBottom: '1rem', fontSize: '1.5rem'}}>Verified Business Entity</h2>
              <p style={{color: '#5b21b6', lineHeight: '1.8'}}>
                RMQ Digital is a verified business entity with complete documentation available for A2P registration, 
                carrier approval processes, and regulatory compliance. We maintain full transparency in our business operations.
              </p>
            </div>

            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem'}}>
              <h3 style={{color: '#1f2937', marginBottom: '1.5rem', fontSize: '1.5rem', fontWeight: '700'}}>Company Information</h3>
              
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem'}}>
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Legal Business Name</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>RMQ HOLDINGS INC</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>DBA (Doing Business As)</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>RMQ Digital</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>EIN (Tax ID)</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>99-1828959</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>D-U-N-S Number</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>129201132</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Date Incorporated</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>November 1, 2023</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Years in Business</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>2 Years (Since 2023)</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Business Type</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>Digital Marketing Agency</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Business Address</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>2022 EAST 9TH STREET<br />BROOKLYN, NY 11223</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Owner</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>MOSHE QUBRUSI</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Industry</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>Digital Marketing & SMS/Email Services</p>
                </div>
                
                <div>
                  <p style={{fontWeight: '600', color: '#6b7280', marginBottom: '0.5rem'}}>Website</p>
                  <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>rmqdigital.com</p>
                </div>
              </div>
            </div>

            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem'}}>
              <h3 style={{color: '#1f2937', marginBottom: '1.5rem', fontSize: '1.5rem', fontWeight: '700'}}>Business Services</h3>
              <p style={{marginBottom: '1rem', lineHeight: '1.8', color: '#4b5563'}}>
                RMQ Digital provides professional digital marketing services including:
              </p>
              <ul style={{lineHeight: '2', paddingLeft: '2rem', color: '#4b5563'}}>
                <li>SMS Marketing Campaigns (A2P 10DLC Compliant)</li>
                <li>Email Marketing Services</li>
                <li>Bulk Messaging Solutions</li>
                <li>Campaign Management & Automation</li>
                <li>Marketing Analytics & Reporting</li>
                <li>Reseller Services & API Access</li>
              </ul>
            </div>

            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem'}}>
              <h3 style={{color: '#1f2937', marginBottom: '1.5rem', fontSize: '1.5rem', fontWeight: '700'}}>Compliance & Certifications</h3>
              
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f9fafb', borderRadius: '12px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>✅</div>
                  <h4 style={{color: '#6d28d9', marginBottom: '0.5rem', fontWeight: '600'}}>TCPA Compliant</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Full compliance with TCPA regulations</p>
                </div>
                
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f9fafb', borderRadius: '12px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>📱</div>
                  <h4 style={{color: '#6d28d9', marginBottom: '0.5rem', fontWeight: '600'}}>A2P Registered</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Carrier-approved messaging</p>
                </div>
                
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f9fafb', borderRadius: '12px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>🔒</div>
                  <h4 style={{color: '#6d28d9', marginBottom: '0.5rem', fontWeight: '600'}}>Data Protected</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Secure data handling practices</p>
                </div>
                
                <div style={{textAlign: 'center', padding: '1.5rem', background: '#f9fafb', borderRadius: '12px'}}>
                  <div style={{fontSize: '2.5rem', marginBottom: '0.5rem'}}>📋</div>
                  <h4 style={{color: '#6d28d9', marginBottom: '0.5rem', fontWeight: '600'}}>CTIA Guidelines</h4>
                  <p style={{fontSize: '0.9rem', color: '#6b7280'}}>Industry best practices</p>
                </div>
              </div>
            </div>

            <div style={{background: '#d1fae5', padding: '2rem', borderRadius: '12px', border: '2px solid #10b981'}}>
              <h3 style={{color: '#065f46', marginBottom: '1rem', fontSize: '1.25rem', fontWeight: '700'}}>Verification Status</h3>
              <p style={{color: '#047857', lineHeight: '1.8'}}>
                ✓ Business entity verified<br />
                ✓ EIN confirmed (99-1828959)<br />
                ✓ D-U-N-S Number verified (129201132)<br />
                ✓ Incorporated November 1, 2023<br />
                ✓ A2P registration complete<br />
                ✓ Compliance documentation on file<br />
                ✓ Carrier approval obtained
              </p>
            </div>

            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <p style={{color: '#6b7280', marginBottom: '1rem'}}>
                For verification inquiries or additional documentation requests:
              </p>
              <p style={{fontSize: '1.1rem', color: '#6d28d9', fontWeight: '600'}}>
                support@rmqdigital.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessVerification;
